import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const KoliLostPageRBAC = {
  pageID: '3f373ceb07fdbeffe1cd94a7c3532414',
  elementID: {
    TableList: '861399e7227e47842b42e3db0c5089b8',
    BtnDetailKoli: '9606c03e795696de402ef0f3eb26e0c8',
    BtnKoliFound: 'ac7c58749ff4e5a58a5a7ec265c53605',
  },
} as const

export const useRBACKoliLostPage = createUseRBAC(KoliLostPageRBAC.elementID)

export type UseRBACGenerateKoliPageType = ReturnType<typeof useRBACKoliLostPage>
